import { render, staticRenderFns } from "./OnlineRentalSettings.vue?vue&type=template&id=0d1cefd4"
import script from "./OnlineRentalSettings.vue?vue&type=script&lang=js"
export * from "./OnlineRentalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports